import { Navbar } from "../components/Navbar";
import { Hero } from "../components/Hero";
import { MenuSection } from "../components/MenuSection";
import { About } from "../components/About";
import { CustomOrder } from "../components/CustomOrder";
import { Testimonials } from "../components/Testimonials";
import { FAQ } from "../components/FAQ";
import { ContactFooter } from "../components/ContactFooter";

export default function Home() {
  return (
    <div className="min-h-screen bg-cream">
      <Navbar />
      <main>
        <Hero />
        <MenuSection />
        <About />
        <CustomOrder />
        <Testimonials />
        <FAQ />
        <ContactFooter />
      </main>
    </div>
  );
}
